import { RewardFareClass } from 'constants/flight'
import { OneWayFlightSaleLabel } from 'components/MaldivesDirect/MaldivesDirectSearchPage/MaldivesDirectCalendar/MaldivesCharterOneWayFlightSaleLabel'

interface Props {
  charterBundleRoute?: App.CharterBundleRoute
  oneWayBundle?: boolean
  fareClass?: string
  departureDate: string | undefined
}

export default function FlashHotelOneWayFlightSaleLabel({ charterBundleRoute, oneWayBundle, fareClass, departureDate }: Props) {
  if (!charterBundleRoute || !oneWayBundle || fareClass !== RewardFareClass.ECONOMY_REWARDS) return null

  return <OneWayFlightSaleLabel departureDate={departureDate} />
}
